import React from "react"
import PropTypes from 'prop-types'

const DefaultImage = ({
  style = {},
  width = "100%",
  className = "default-image",
  viewBox = "0 0 176 121"
}) => (
  <svg
    width={width}
    style={style}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
  >
    <defs>
      <path id="a" d="M27.947 27.186l7.948 16.136H.161l7.947-16.136H4.639L18.028 0l13.389 27.186z"/>
      <path id="b" d="M29.362 0v20.789H.027z"/>
      <path id="d" d="M58.724 0v41.578H.054z"/>
      <path id="f" d="M0 0h22.037v52.761H0z"/>
      <path id="h" d="M0 0h22.037v52.761H0z"/>
      <path d="M3.2.098L6.163.42l1.998 7.951c4.072 10.913 5.924 16.618 5.559 17.115C8.943 31.983 2.097 27.458.8 27.678c-1.444.246-.867-5.896 1.732-18.427-.288-1.328-.577-2.304-.866-2.925C1.38 5.704 1.89 3.628 3.2.098z" id="j"/>
      <path d="M3.887.06A3.823 3.823 0 017.71 3.883v6.71a3.823 3.823 0 11-7.646 0v-6.71A3.823 3.823 0 013.887.06z" id="l"/>
      <path d="M2.237.199l.207 2.49c-1.058.264-1.739.234-2.041-.088-.208-.221-.12-.43-.01-.968.034-.164.072-.5.114-1.008L2.237.2z" id="n"/>
      <path id="p" d="M.083 1.857L9.922 0l.446 6.754L.93 8.745z"/>
      <path id="r" d="M.02.308l2.44-.24-.936 13.398z"/>
      <path d="M0 4.17C.366 1.829.845.549 1.436.33 2.421-.037 3.37 0 4.286.438 4.066 3.73 3.59 5.45 2.857 5.596 2.125 5.743 1.172 5.267 0 4.17z" id="t"/>
      <path id="v" d="M1.269.099h3.637v18.762H1.269z"/>
      <path id="x" d="M1.267.098h3.629v18.654H1.267z"/>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d="M40.04 54l13.292 27.306-3.445-.001 7.89 16.209-4.79-.001 9.825 20.185H17.27l9.825-20.185h-4.79l7.889-16.208H26.75L40.04 54z" fill="#FFB53D" fillRule="nonzero"/>
      <g fillRule="nonzero">
        <g transform="translate(12 90)">
          <ellipse fill="#447DB2" cx="11" cy="10.969" rx="10.979" ry="10.948"/>
          <path stroke="#195287" strokeWidth="3.81" strokeLinecap="round" strokeLinejoin="round" d="M11 13.102v13.669"/>
          <path d="M11.338 17.887a5.627 5.627 0 002.031-4.327v-.566h0" stroke="#195287" strokeWidth="3.81" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M10.83 19.936A5.627 5.627 0 018.8 15.61v-1.41h0" stroke="#195287" strokeWidth="3.81" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
        <g transform="translate(12.846 105.019)">
          <ellipse fill="#5E9AD2" cx="4.328" cy="4.293" rx="4.302" ry="4.29"/>
          <path d="M5.077 4.788a4.219 4.219 0 004.219 4.219h.689" stroke="#195287" strokeWidth="3.81" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M5.077 7.088a1.523 1.523 0 01-1.523-1.524v-.67h0" stroke="#195287" strokeWidth="3.81" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
      </g>
      <path d="M118.959 26l13.389 27.186-3.47-.001 7.948 16.137H132l9.897 20.095H96.02l9.897-20.095h-4.824l7.947-16.137h-3.47L118.96 26z" fill="#FFB53D" fillRule="nonzero"/>
      <path fill="#FFB53D" fillRule="nonzero" d="M88.235 96.177h52.761v23.752H88.235z"/>
      <use fill="#FF9E00" fillRule="nonzero" xLinkHref="#a" transform="translate(95.617 38.23)"/>
      <g fillRule="nonzero">
        <g transform="matrix(-1 0 0 1 160.759 89.538)">
          <ellipse fill="#447DB2" cx="11.23" cy="11.16" rx="11.208" ry="11.139"/>
          <path stroke="#195287" strokeWidth="3.81" strokeLinecap="round" strokeLinejoin="round" d="M11.23 13.331v13.908"/>
          <path d="M11.575 18.2a5.725 5.725 0 002.073-4.409v-.57h0" stroke="#195287" strokeWidth="3.81" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M11.057 20.285a5.725 5.725 0 01-2.073-4.409v-1.429h0" stroke="#195287" strokeWidth="3.81" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
        <g transform="matrix(-1 0 0 1 159.895 104.82)">
          <ellipse fill="#5E9AD2" cx="4.419" cy="4.368" rx="4.392" ry="4.365"/>
          <path d="M5.183 4.872a4.292 4.292 0 004.292 4.292h.718" stroke="#195287" strokeWidth="3.81" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M5.183 7.211a1.555 1.555 0 01-1.555-1.555V4.98h0" stroke="#195287" strokeWidth="3.81" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
      </g>
      <path fill="#B4D5F3" fillRule="nonzero" d="M37.343 41.005h80.421V119H37.343z"/>
      <g transform="matrix(-1 0 0 1 117.997 21.506)">
        <mask id="c" fill="#fff">
          <use xLinkHref="#b"/>
        </mask>
        <use fill="#9AC6EE" fillRule="nonzero" xLinkHref="#b"/>
        <path fill="#88B9E5" fillRule="nonzero" mask="url(#c)" transform="rotate(-35 16.126 10.863)" d="M-1.485 10.378l35.224-.032-.001 1.003-35.224.032z"/>
      </g>
      <path fill="#CCE4FA" fillRule="nonzero" d="M116.575 41.07L87.74 20.84l-.575.822 28.836 20.23z"/>
      <g transform="translate(37.29 1.434)">
        <mask id="e" fill="#fff">
          <use xLinkHref="#d"/>
        </mask>
        <use fill="#B4D5F3" fillRule="nonzero" xLinkHref="#d"/>
        <path fill="#9AC6EE" fillRule="nonzero" mask="url(#e)" transform="rotate(-35 32.253 21.726)" d="M-2.971 20.755l70.449-.064-.002 2.006-70.448.064z"/>
      </g>
      <path fill="#CCE4FA" fillRule="nonzero" d="M40.132 40.561L97.804.101l1.149 1.644-57.671 40.46z"/>
      <path fill="#CCE4FA" fillRule="nonzero" d="M35.197 38.998h84.714v4.014H35.197z"/>
      <g>
        <g transform="translate(49.364 51.557)">
          <mask id="g" fill="#fff">
            <use xLinkHref="#f"/>
          </mask>
          <use fill="#82B9EB" fillRule="nonzero" xLinkHref="#f"/>
          <g opacity=".2" mask="url(#g)" fill="#FFF" fillRule="nonzero">
            <path d="M23.098 8.944l3.5 3.379-29.481 30.528-3.5-3.38z"/>
            <path d="M27.215 12.92l1.44 1.391L-.824 44.84l-1.44-1.391z"/>
          </g>
          <path fill="#B4D5F3" fillRule="nonzero" mask="url(#g)" d="M10.017-.287h1.145v53.622h-1.145z"/>
          <path fill="#B4D5F3" fillRule="nonzero" mask="url(#g)" transform="rotate(90 10.875 18.352)" d="M10.302 7.047h1.147v22.61h-1.147z"/>
          <path fill="#B4D5F3" fillRule="nonzero" mask="url(#g)" transform="rotate(90 10.875 35.557)" d="M10.302 24.252h1.147v22.609h-1.147z"/>
        </g>
        <g transform="translate(83.707 51.5)">
          <mask id="i" fill="#fff">
            <use xLinkHref="#h"/>
          </mask>
          <use fill="#82B9EB" fillRule="nonzero" xLinkHref="#h"/>
          <g opacity=".2" mask="url(#i)" fill="#FFF" fillRule="nonzero">
            <path d="M23.098 8.944l3.5 3.379-29.481 30.528-3.5-3.38z"/>
            <path d="M27.215 12.92l1.44 1.391L-.824 44.84l-1.44-1.391z"/>
          </g>
          <path fill="#B4D5F3" fillRule="nonzero" mask="url(#i)" d="M10.017-.287h1.145v53.622h-1.145z"/>
          <path fill="#B4D5F3" fillRule="nonzero" mask="url(#i)" transform="rotate(90 10.875 18.352)" d="M10.302 7.047h1.147v22.61h-1.147z"/>
          <path fill="#B4D5F3" fillRule="nonzero" mask="url(#i)" transform="rotate(90 10.875 35.557)" d="M10.302 24.252h1.147v22.609h-1.147z"/>
        </g>
      </g>
      <g fillRule="nonzero">
        <g transform="translate(109 71)">
          <ellipse fill="#4C85BA" cx="18.5" cy="18.805" rx="18.464" ry="18.769"/>
          <path stroke="#195287" strokeWidth="6.35" strokeLinecap="round" strokeLinejoin="round" d="M18.5 22.463v23.433"/>
          <path d="M19.07 30.667a9.658 9.658 0 003.415-7.37v-1.02h0" stroke="#195287" strokeWidth="6.35" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M18.215 34.18a9.658 9.658 0 01-3.415-7.37v-2.467h0" stroke="#195287" strokeWidth="6.35" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
        <g transform="translate(110.423 96.748)">
          <ellipse fill="#5E9AD2" cx="7.28" cy="7.36" rx="7.236" ry="7.355"/>
          <path d="M8.538 8.209a7.233 7.233 0 007.233 7.233h1.021" stroke="#195287" strokeWidth="6.35" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M8.538 12.15a2.562 2.562 0 01-2.561-2.56v-1.2h0" stroke="#195287" strokeWidth="6.35" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
      </g>
      <path fill="#2C669C" fillRule="nonzero" d="M0 118h176v2H0z"/>
      <g>
        <g fillRule="nonzero">
          <path d="M50.548 114.806l-1.453-.306-.651 1.398c3.002 1.273 4.691 1.812 5.067 1.617.377-.195-.611-1.098-2.963-2.71z" fill="#242D3C"/>
          <path fill="#FFE9DE" d="M57.103 88.907l-1.732 10.474-6.278 15.171 1.3.293 8.442-13.413 3.897-11.666z"/>
        </g>
        <path fill="#FFE9DE" fillRule="nonzero" d="M64.897 78.943l.866.949 7.36 2.576 1.732.429.433 1.717-1.299-.43v.43h-.866v-.858l-7.793-1.977-3.03-2.316z"/>
        <path fill="#2C669C" fillRule="nonzero" d="M61.962 75.599l3.801 3.864-1.732 2.146-2.598-2.666z"/>
        <g fillRule="nonzero">
          <path d="M62.732 89.336l2.87 9.73.161 17.316H64.248l-2.815-16.304c-3.002-4.456-4.59-6.963-4.762-7.522-.484-1.56-.484-3.206 0-4.937l6.061 1.717z" fill="#FFE9DE"/>
          <path d="M65.735 116.335h-1.486l-.344 1.503c3.204.626 4.97.805 5.296.537.327-.269-.828-.949-3.466-2.04z" fill="#313C4D"/>
        </g>
        <g transform="matrix(-1 0 0 1 66.564 74.955)">
          <mask id="k" fill="#fff">
            <use xLinkHref="#j"/>
          </mask>
          <use fill="#3473AD" fillRule="nonzero" xLinkHref="#j"/>
          <path fill="#2C669C" fillRule="nonzero" mask="url(#k)" d="M4.698 4.344l2.165 4.457 1.732-1.912z"/>
        </g>
        <path fill="#FFE9DE" fillRule="nonzero" d="M56.596 80.197l-1.53 2.378-1.402 8.74.924.516 1.924-7.658 2.792-2.828z"/>
        <path fill="#3473AD" fillRule="nonzero" d="M60.325 75.375l-4.088 4.856 2.598 2.237 3.031-3.435z"/>
        <g transform="scale(-1 1) rotate(-15 327.477 254.133)">
          <g transform="translate(0 10.2)">
            <mask id="m" fill="#fff">
              <use xLinkHref="#l"/>
            </mask>
            <use fill="#F19B11" fillRule="nonzero" xLinkHref="#l"/>
            <path fill="#FFB53D" fillRule="nonzero" mask="url(#m)" d="M-.318-2.125h4.715v17H-.318z"/>
          </g>
          <rect fill="#FFB53D" fillRule="nonzero" x="6.112" y="16.575" width="2.572" height="7.65" rx="1.286"/>
          <g transform="translate(1.396 22.95)" fillRule="nonzero">
            <ellipse fill="#242D3C" cx="1.286" cy="1.275" rx="1.286" ry="1.275"/>
            <circle fill="#313C4D" cx="1.286" cy="1.275" r="1"/>
          </g>
          <rect fill="#242D3C" fillRule="nonzero" x=".968" width="1" height="11.9" rx=".5"/>
        </g>
        <path fill="#FFE9DE" fillRule="nonzero" d="M53.843 91.054l-1.732 1.952.866.96.866.413.866-3.005z"/>
        <path fill="#FFB53D" fillRule="nonzero" d="M74.422 83.326l2.165-2.146 4.33 5.962-7.794 3.482-2.598-4.722z"/>
        <path d="M73.557 84.614c.144 0 .288-.43.433-1.288h-.433l-.433.43c.144.572.288.858.433.858z" fill="#FFE9DE" fillRule="nonzero"/>
        <g>
          <g transform="scale(-1 1) rotate(-7 566.127 560.778)">
            <mask id="o" fill="#fff">
              <use xLinkHref="#n"/>
            </mask>
            <use fill="#FFE9DE" fillRule="nonzero" transform="rotate(-12 1.36 1.533)" xLinkHref="#n"/>
            <path fill="#F9C9AF" fillRule="nonzero" mask="url(#o)" d="M1.44.448L-.134 3.112-.402.679z"/>
          </g>
          <path d="M62.852 73.747c.887 1.064 1.494 1.445 1.822 1.143.196-.18.509-.65.827-1.4.142-.337.254-.95.334-1.836l-3.119-1.243-.548 2.686.684.65z" fill="#FFE9DE" fillRule="nonzero"/>
          <path d="M62.959 71.987c-.408-.192-.831 2.822-1.873 4.141-1.326 1.68-3.4 1.778-4.977 1.675-2.812-.185-4.336-6.87-1.521-6.038 2.815.83 5.154-.668 5.41-1.864.12-.564 1.4-2.439 2.956-2.637 1.556-.199 3.636 1.693 3.719 2.898.156 2.279-2.787 2.264-3.714 1.825z" fill="#313C4D" fillRule="nonzero"/>
        </g>
      </g>
      <g>
        <path fill="#242D3C" fillRule="nonzero" d="M95.3 86.534l2.462 29.419 2.34-.797V85.819z"/>
        <path fill="#313C4D" fillRule="nonzero" d="M98.91 86.534l6.353 28.21 2.08-.796-3.63-28.13z"/>
        <path fill="#2C669C" fillRule="nonzero" d="M105.868 90.71l3.146-.692.363 1.513h-.363l-.242-.865-2.662.456.242.998h-.363z"/>
        <path fill="#235C91" fillRule="nonzero" d="M101.996 92.376l9.68-1.948.726.121-4.477 1.827-4.96.737z"/>
        <g transform="translate(102.48 90.549)">
          <mask id="q" fill="#fff">
            <use xLinkHref="#p"/>
          </mask>
          <use fill="#2C669C" fillRule="nonzero" xLinkHref="#p"/>
          <path fill="#4782B8" fillRule="nonzero" mask="url(#q)" d="M.363 5.578l10.285-2.324-.363-3.776L-.242 1.262z"/>
        </g>
        <path fill="#235C91" fillRule="nonzero" d="M103.448 99.264l-.605-.248-.847-6.64h.605"/>
        <path fill="#FFF" fillRule="nonzero" d="M104.78 94.657l.846-.206.242 2.018-.847.206z"/>
        <path fill="#FFF" fillRule="nonzero" d="M110.103 93.45l.847-.207.121 2.018-.847.206z"/>
        <path d="M98.238 115.587c-3.45 2.075-4.783 3.113-3.999 3.113.784 0 2.744-.665 5.88-1.996v-1.647l-1.881.53z" fill="#242D3C" fillRule="nonzero"/>
        <path d="M105.445 114.378c-1.837 2.882-2.363 4.322-1.58 4.322.785 0 2-1.168 3.644-3.503l-.183-1.348-1.881.53z" fill="#313C4D" fillRule="nonzero"/>
        <path d="M106.92 88.135l-.639 1.857c.287.754.614 1.107.981 1.06.367-.046.82-.499 1.358-1.357l-.957-1.56h-.744z" fill="#FFD9C4" fillRule="nonzero"/>
        <path d="M83.725 68.317c-.42-.843-.703-1.332-.847-1.467-.216-.201-.726-.62-.726 0s-1.573-1.19-1.815-.877c-.242.315-.605 1.62.605 2.344.807.484 1.452.725 1.936.725l.847-.725z" fill="#FFD9C4" fillRule="nonzero"/>
        <g>
          <path fill="#313C4D" fillRule="nonzero" d="M105.384 71.277l4.235 8.025-1.452 9.288h-1.452V80.4l-3.63-4.267z"/>
          <path d="M100.431 70.287l.3.016a4.671 4.671 0 014.375 5.355l-.743 4.972.542 8.282-10.875-.57 1.153-13.483a5.005 5.005 0 015.248-4.572z" fill="#313C4D" fillRule="nonzero"/>
          <g transform="rotate(3 -1292.938 1924.846)">
            <mask id="s" fill="#fff">
              <use xLinkHref="#r"/>
            </mask>
            <use fill="#FFF" fillRule="nonzero" xLinkHref="#r"/>
            <path fill="#2C669C" fillRule="nonzero" mask="url(#s)" d="M.777.873L.222 7.628l1.309 7.613.986-6.605L1.791.665z"/>
          </g>
          <path fill="#313C4D" fillRule="nonzero" d="M96.672 70.13l-7.623 3.676-5.446-5.69-.726.96 5.325 8.665 8.47-2.76z"/>
          <path d="M101.167 67.659l.224 2.837c-.41.507-.813.767-1.21.781-.396.014-.797-.218-1.202-.696l.481-3.42 1.707.498z" fill="#FFD9C4" fillRule="nonzero"/>
          <g transform="scale(-1 1) rotate(-14 210.84 447.783)">
            <mask id="u" fill="#fff">
              <use xLinkHref="#t"/>
            </mask>
            <use fill="#FFD9C4" fillRule="nonzero" xLinkHref="#t"/>
            <path fill="#F69C7E" fillRule="nonzero" mask="url(#u)" d="M.44 2.853l-.44.11.11-.317.22-.122z"/>
          </g>
          <path d="M101.188 66.012c-.232-.586-.374-1.074-.428-1.464-2.167.213-3.491.223-3.97.028-.72-.293.156-2.902 2.155-2.743 1.333.107 2.444.47 3.335 1.09.688.315.892 1.033.612 2.156-.28 1.124-.811 2.197-1.595 3.222l-.267.16.158-2.45z" fill="#313C4D" fillRule="nonzero"/>
          <path d="M101.1 65.906c.305-.332.522-.36.651-.083.129.277-.139.66-.802 1.147l.152-1.064z" fill="#FFD9C4" fillRule="nonzero"/>
          <path fill="#FFF" fillRule="nonzero" d="M98.971 70.492l-.484 1.357 1.694-.572z"/>
          <path fill="#FFF" fillRule="nonzero" d="M100.06 71.277l1.331-.821.484 1.124z"/>
        </g>
      </g>
      <g>
        <g transform="translate(57 20)">
          <path fill="#CAD8EC" fillRule="nonzero" d="M.133.099h4.773v18.762H.133z"/>
          <mask id="w" fill="#fff">
            <use xLinkHref="#v"/>
          </mask>
          <use fill="#E1EAF6" fillRule="nonzero" xLinkHref="#v"/>
          <path d="M-7.623-16.442h54.78c1.003 0 1.815.812 1.815 1.814V6.918a1.814 1.814 0 01-1.815 1.815h-54.78a1.814 1.814 0 01-1.814-1.815v-21.546c0-1.002.812-1.814 1.814-1.814z" fill="#CAD8EC" fillRule="nonzero" opacity=".5" mask="url(#w)"/>
        </g>
        <g transform="translate(87 20)">
          <path fill="#CAD8EC" fillRule="nonzero" d="M.133.098h4.763v18.654H.133z"/>
          <mask id="y" fill="#fff">
            <use xLinkHref="#x"/>
          </mask>
          <use fill="#E1EAF6" fillRule="nonzero" xLinkHref="#x"/>
          <path d="M-29.355-16.347h54.659c1.002 0 1.814.812 1.814 1.814v21.4a1.814 1.814 0 01-1.814 1.815h-54.66a1.814 1.814 0 01-1.814-1.815v-21.4c0-1.002.813-1.814 1.815-1.814z" fill="#CAD8EC" fillRule="nonzero" opacity=".5" mask="url(#y)"/>
        </g>
        <path d="M51.931 7.25h46.142c1.002 0 1.814.812 1.814 1.814v21.884a1.814 1.814 0 01-1.814 1.814H51.93a1.814 1.814 0 01-1.814-1.814V9.064c0-1.002.812-1.814 1.814-1.814z" fill="#EB9304" fillRule="nonzero"/>
        <path d="M53.012 7.083h45.06c1.003 0 1.815.812 1.815 1.814v21.884a1.814 1.814 0 01-1.814 1.814h-45.06a1.814 1.814 0 01-1.815-1.814V8.897c0-1.002.812-1.814 1.814-1.814z" fill="#FFB53D" fillRule="nonzero"/>
        <path d="M79.173 25.565c-3.342 0-6.217-2.471-6.217-5.752 0-3.28 2.853-5.858 6.195-5.858 3.343 0 6.057 2.581 6.057 5.862 0 3.28-2.693 5.748-6.035 5.748zm-.236-2.8c2.052 0 3.651-1.523 3.651-3.405 0-1.881-1.572-3.471-3.624-3.471s-3.82 1.594-3.82 3.475c0 1.882 1.74 3.402 3.793 3.402z" fill="#EB9304" fillRule="nonzero"/>
        <path d="M79.713 25.565c-3.342 0-6.217-2.471-6.217-5.752 0-3.28 2.854-5.858 6.196-5.858 3.342 0 6.056 2.581 6.056 5.862 0 3.28-2.693 5.748-6.035 5.748zm-.236-2.8c2.052 0 3.652-1.523 3.652-3.405 0-1.881-1.572-3.471-3.624-3.471s-3.82 1.594-3.82 3.475c0 1.882 1.74 3.402 3.792 3.402z" fill="#FFF" fillRule="nonzero"/>
        <path d="M63.582 13.745c.61 1.674 1.768 5.682 3.475 12.025l1.522.01c.877-.31 1.567-1.053 2.07-2.23.755-1.766 1.577-4.647 1.668-5.02.09-.373.904-3.736 4.317-4.785-2.337-.04-4.788.52-5.725 1.89-.624.915-1.351 2.954-2.182 6.117-1.041-3.675-1.615-5.619-1.721-5.832-.16-.32-.937-2.32-3.424-2.175z" fill="#EB9304"/>
        <path d="M64.122 13.745c.61 1.674 1.768 5.682 3.476 12.025l1.522.01c.877-.31 1.567-1.053 2.07-2.23.755-1.766 1.577-4.647 1.667-5.02.09-.373.905-3.736 4.317-4.785-2.336-.04-4.787.52-5.724 1.89-.625.915-1.352 2.954-2.182 6.117-1.041-3.675-1.615-5.619-1.722-5.832-.159-.32-.936-2.32-3.424-2.175z" fill="#FFF"/>
        <g transform="translate(52.848 9.166)" fill="#EB9304" fillRule="nonzero">
          <circle cx=".981" cy=".963" r="1"/>
          <circle cx="6.375" cy=".963" r="1"/>
          <circle cx="11.769" cy=".963" r="1"/>
          <circle cx="17.041" cy=".842" r="1"/>
          <circle cx="22.19" cy=".842" r="1"/>
          <circle cx="27.339" cy=".842" r="1"/>
          <circle cx="32.488" cy=".842" r="1"/>
          <circle cx="37.637" cy=".842" r="1"/>
          <circle cx="42.902" cy=".842" r="1"/>
          <circle cx=".981" cy="20.218" r="1"/>
          <circle cx="6.375" cy="20.218" r="1"/>
          <circle cx="11.769" cy="20.218" r="1"/>
          <circle cx="17.041" cy="20.097" r="1"/>
          <circle cx="22.19" cy="20.097" r="1"/>
          <circle cx="27.339" cy="20.097" r="1"/>
          <circle cx="32.488" cy="20.097" r="1"/>
          <circle cx="37.637" cy="20.097" r="1"/>
          <circle cx="42.902" cy="20.097" r="1"/>
          <circle cx="42.902" cy="5.656" r="1"/>
          <circle cx="42.902" cy="10.47" r="1"/>
          <circle cx="42.902" cy="15.284" r="1"/>
          <circle cx="1.103" cy="5.656" r="1"/>
          <circle cx="1.103" cy="10.47" r="1"/>
          <circle cx="1.103" cy="15.284" r="1"/>
        </g>
        <g transform="translate(53.583 9.166)" fill="#FFF" fillRule="nonzero">
          <circle cx=".981" cy=".963" r="1"/>
          <circle cx="6.375" cy=".963" r="1"/>
          <circle cx="11.769" cy=".963" r="1"/>
          <circle cx="17.041" cy=".842" r="1"/>
          <circle cx="22.19" cy=".842" r="1"/>
          <circle cx="27.339" cy=".842" r="1"/>
          <circle cx="32.488" cy=".842" r="1"/>
          <circle cx="37.637" cy=".842" r="1"/>
          <circle cx="42.902" cy=".842" r="1"/>
          <circle cx=".981" cy="20.218" r="1"/>
          <circle cx="6.375" cy="20.218" r="1"/>
          <circle cx="11.769" cy="20.218" r="1"/>
          <circle cx="17.041" cy="20.097" r="1"/>
          <circle cx="22.19" cy="20.097" r="1"/>
          <circle cx="27.339" cy="20.097" r="1"/>
          <circle cx="32.488" cy="20.097" r="1"/>
          <circle cx="37.637" cy="20.097" r="1"/>
          <circle cx="42.902" cy="20.097" r="1"/>
          <circle cx="42.902" cy="5.656" r="1"/>
          <circle cx="42.902" cy="10.47" r="1"/>
          <circle cx="42.902" cy="15.284" r="1"/>
          <circle cx="1.103" cy="5.656" r="1"/>
          <circle cx="1.103" cy="10.47" r="1"/>
          <circle cx="1.103" cy="15.284" r="1"/>
        </g>
      </g>
    </g>
  </svg>
)

DefaultImage.propTypes = {
  style: PropTypes.object,
  fill: PropTypes.string,
  width: PropTypes.string,
  className: PropTypes.string,
  viewBox: PropTypes.string
}

export default DefaultImage
